import { render, staticRenderFns } from "./BetslipContent.vue?vue&type=template&id=271ccb9a&"
import script from "./BetslipContent.vue?vue&type=script&lang=js&"
export * from "./BetslipContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports